import { HIPAATIZER_ORIGINS } from './hipaatizer.js';

export const CONSULT_WORKFLOW_ID = '01a193d1-0f98-700d-bb99-8268a3ce1989';
const CONSULT_FORM_ID = 'f2fc7047-bb14-4459-af8c-00b94699e3b4';
export const HIPAATIZER_UTM_KEYS = Object.freeze(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']);

export function sanitizeHipaatizerAttribution(values = {}) {
  return Object.fromEntries(HIPAATIZER_UTM_KEYS.flatMap(key => {
    const value = values?.[key];
    return typeof value === 'string' && /^[a-z0-9_.-]{1,200}$/i.test(value)
      ? [[key, value]] : [];
  }));
}

// Only this verified consultation form receives the approved campaign metadata.
export function hipaatizerAttributionValues(workflowId, tracking = {}) {
  if (workflowId !== CONSULT_WORKFLOW_ID ||
      tracking?.measurement_consent !== 'granted' ||
      !/^\/consult\/?$/i.test(tracking?.source_page || '')) return {};
  return sanitizeHipaatizerAttribution(tracking);
}

export function hipaatizerInitialValues(workflowId, tracking = {}) {
  const data = hipaatizerAttributionValues(workflowId, tracking);
  return Object.keys(data).length
    ? JSON.stringify([{ data, formId: CONSULT_FORM_ID }])
    : 'null';
}

export function hipaatizerIframeSrc(workflowId, tracking = {}) {
  const size = typeof window !== 'undefined' && window.innerWidth < 700 ? 'mobile' : 'desktop';
  const q = new URLSearchParams({
    initialValues: hipaatizerInitialValues(workflowId, tracking),
    size,
    isStartMultiWorkflow: 'false',
    isAdvancedWorkflow: 'false',
  });
  return `${HIPAATIZER_ORIGINS[0]}/workflow/${encodeURIComponent(workflowId)}?${q}`;
}

export function hipaatizerOpenUrl(form, tracking = {}) {
  const workflowId = form?.workflow_id || '';
  if (workflowId === CONSULT_WORKFLOW_ID) return hipaatizerIframeSrc(workflowId, tracking);
  return form?.embed_url || (workflowId ? hipaatizerIframeSrc(workflowId) : '');
}

